// extracted by mini-css-extract-plugin
export default {"followUp":"styles_followUp__eju44","bolded":"styles_bolded__FcU6c"};